import InvoicingContainer from "./InvoicingContainer";

export default InvoicingContainer;
